module.exports = __webpack_public_path__ + "img/coreintercomDesk.b2014f10.png";